/**
 * Acronyms whose casing PascalCase ids do not preserve — `SourceObdId` has to read "OBD", not
 * "Obd". Matched on whole words only, so "Cancel" does not become "CANcel".
 *
 * Compiled once. Built per call this ran six times for every reading on the page.
 */
const ACRONYMS = /\b(fms|obd|can|gps|vin|iox)\b/gi;

const WORD_BOUNDARY = /([a-z])([A-Z])/g;

/**
 * Turns a Geotab enum id into something readable.
 *
 * Geotab reports these as `SourceGoDeviceId` or `DiagnosticEngineSpeedId`; a grid needs
 * "Go Device". The explicit `…NoneId` value means "not set" and becomes an empty string rather
 * than the word "None".
 *
 * @param id - The Geotab id, e.g. `SourceObdId`.
 * @param prefix - The id family, e.g. `Source` or `Diagnostic`.
 */
export function parseGeotabId(id: string, prefix: string): string {
  if (!id || id === `${prefix}NoneId`) {
    return "";
  }

  let name = id;
  if (name.startsWith(prefix)) {
    name = name.slice(prefix.length);
  }
  if (name.endsWith("Id")) {
    name = name.slice(0, -2);
  }

  return name
    .replace(WORD_BOUNDARY, "$1 $2")
    .replace(ACRONYMS, acronym => acronym.toUpperCase());
}
